var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"sub-nav"},[_c('ul',{staticClass:"nav-list"},[_c('li',[_c('router-link',{attrs:{"to":"/html"}},[_vm._v("Rendered")])],1),_c('li',[_c('router-link',{attrs:{"to":"/html/source"}},[_vm._v("Source")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }